import type {
  CommonRequestFn,
  CommonRequestFnWithoutPayload
} from "@marketplace/http";
import type { BaseResponse } from "@marketplace/shared/types";

import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";
import type { GetProfileDataResponseDto } from "@/modules/auth/dtos/get-profile-data-response-dto";

import type { ChangePasswordRequestDto } from "../dtos/change-password-request-dto";
import type { UpdateProfileRequestDto } from "../dtos/update-profile-request-dto";

type ProfileServiceContract = {
  changePassword: CommonRequestFn<ChangePasswordRequestDto, any>;
  validateChangePassword: CommonRequestFn<
    Omit<ChangePasswordRequestDto, "otp_code">,
    BaseResponse<null>
  >;
  changePasswordWithOtp: CommonRequestFn<
    ChangePasswordRequestDto,
    BaseResponse<null>
  >;
  getProfileData: CommonRequestFnWithoutPayload<GetProfileDataResponseDto>;
  updateProfile: CommonRequestFn<
    Partial<UpdateProfileRequestDto>,
    GetProfileDataResponseDto
  >;
};

export const ProfileService: ProfileServiceContract = {
  changePassword: async ({ payload, options }) => {
    return await httpClient
      .put(ENDPOINTS.PROFILE.CHANGE_PASSWORD, {
        json: payload,
        ...options
      })
      .json();
  },

  validateChangePassword: async ({ payload, options }) => {
    return await httpClient
      .post(ENDPOINTS.PROFILE.CHANGE_PASSWORD_WITH_OTP, {
        json: {
          old_password: payload.old_password,
          password: payload.password,
          confirm_password: payload.confirm_password
        },
        ...options
      })
      .json<BaseResponse<null>>();
  },

  changePasswordWithOtp: async ({ payload, options }) => {
    return await httpClient
      .put(ENDPOINTS.PROFILE.CHANGE_PASSWORD, {
        json: {
          old_password: payload.old_password,
          password: payload.password,
          confirm_password: payload.confirm_password,
          otp_code: payload.otp_code
        },
        ...options
      })
      .json<BaseResponse<null>>();
  },

  getProfileData: async (params) => {
    return await httpClient
      .get(ENDPOINTS.PROFILE.USER_DATA, {
        ...params?.options
      })
      .json<GetProfileDataResponseDto>();
  },

  updateProfile: async ({ payload, options }) => {
    return await httpClient
      .put(ENDPOINTS.PROFILE.UPDATE_PROFILE, {
        json: payload,
        ...options
      })
      .json<GetProfileDataResponseDto>();
  }
};
